import React, { ReactNode } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import { isEmpty, map, slice } from 'lodash';
import { colorOpacity, customTheme } from 'theme';

import { AriksaIcon, getIconColor, Tag } from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

export const renderRiskContextIcon = (item, tooltips = {}) => {
  const color = getIconColor(item?.severity);
  return (
    <CustomTooltip label={tooltips?.[item?.type] ?? item?.type}>
      <AriksaIcon
        type={item?.type}
        //bg={colorOpacity(color, 0.2)}
        color={color}
        //borderColor={color}
        iconFilled={false}
        border={false}
        useCustomColor
        style={{ w: 7, h: 7, p: 1, _hover: { bg: colorOpacity(color, 0.1) } }}
      />
    </CustomTooltip>
  );
};

export const renderRiskContext = (
  data: Record<string, any>[],
  tooltips?: Record<string, ReactNode>,
  align?: string,
  pr?: string | number,
) => {
  const renderIcon = item => renderRiskContextIcon(item, tooltips);
  return !isEmpty(data) ? (
    <Stack spacing={0} w="full" align={align} pr={pr}>
      <HStack spacing={0.5}>
        {data?.[0] && renderIcon(data?.[0])}
        {data?.[1] && renderIcon(data?.[1])}
        {data?.[2] && renderIcon(data?.[2])}
      </HStack>
      <HStack spacing={0.5}>
        {data?.[3] && renderIcon(data?.[3])}
        {data?.[4] && renderIcon(data?.[4])}
        {data?.[5] && data?.length === 6 && renderIcon(data?.[5])}
        {data?.length > 6 && (
          <CustomTooltip
            label={
              <Stack>
                {map(slice(data, 5), (o, index) => (
                  <Box key={index + '-' + o?.type + '-risk-context'}>
                    {o?.type}
                  </Box>
                ))}
              </Stack>
            }
          >
            <Tag
              label={<Box>+{data?.length - 5}</Box>}
              styles={{
                tag: {
                  px: 1,
                  py: '2px',
                  bg: colorOpacity(customTheme.colors.primary, 0.1),
                  border: 'none',
                },
              }}
            />
          </CustomTooltip>
        )}
      </HStack>
    </Stack>
  ) : (
    <Box pr={pr}>-</Box>
  );
};
